module.exports = __webpack_public_path__ + "static/media/filter.ea983fd6.svg";